import AppDataService from "./AppDataService";

const COMMON_BASE = 'Recipient'

export default class RecipientDataService {
    static async getRecipientList(formAndPayerData) {
        return await AppDataService.post(`${COMMON_BASE}/List`, formAndPayerData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async getRecipient(recipientId) {
        return await AppDataService.get(`${COMMON_BASE}/Get/${recipientId}`)
    }

    static async getPaginatedRecipientList(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetRecipientListFilter`, { params });
    }

    static async saveRecipient(recipientData) {
        return await AppDataService.post(`${COMMON_BASE}/Save`, recipientData);
    }

    static async deleteRecipient(data) {
        return await AppDataService.delete(`${COMMON_BASE}/Delete`, data);
    }

    static async getTemplate() {
        return await AppDataService.get(`${COMMON_BASE}/GetTemplate`)
    }

    static async uploadSheet(data) {
        return await AppDataService.post(`${COMMON_BASE}/UploadSheet`, data)
    }

    static async validateSheetRecords(params) {
        return await AppDataService.get(`${COMMON_BASE}/BulkSave`, { params })
    }

    static async getErrorReport() {
        return await AppDataService.get(`${COMMON_BASE}/GetErrorSheet`)
    }

    static async getRequestedCount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetRequestedCount`, data)
    }

    static async tinMatchRequest(data) {
        return await AppDataService.post(`${COMMON_BASE}/TinmatchRequest`, data)
    }

    static async editRecipient(recipientData) {
        return await AppDataService.post(`${COMMON_BASE}/Edit`, recipientData);
    }

    static async processBulkAddressValidation(data) {
        return await AppDataService.post(`${COMMON_BASE}/BulkAddressMatch`, data)
    }

    static async recipientExportForAllPayers(formName) {
        return await AppDataService.get(`${COMMON_BASE}/RecipientExportForAllPayers?FormName=${formName}`)
    }

    static async exportSelectedRecipients(data) {
        return await AppDataService.post(`${COMMON_BASE}/RecipientExportbyPayer`, data)
    }
    static async getW8Forms() {
        return await AppDataService.get(`${COMMON_BASE}/GetW8Forms`)
    }

    static async requestBulkW8(data) {
        return await AppDataService.post(`${COMMON_BASE}/RequestBulkW8`, data)
    }

    static async isDisplayPlansView() {
        return await AppDataService.get(`${COMMON_BASE}/IsDisplayPlansView`)
    }

    static async getW8RequestedCount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetW8RequestedCount`, data)
    }

    static async getW9RequestedCount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetW9RequestedCount`, data)
    }

    static async requestBulkW9(data) {
        return await AppDataService.post(`${COMMON_BASE}/RequestBulkW9`, data)
    }

    static async processBulkAddressValidation(data) {
        return await AppDataService.post(`${COMMON_BASE}/BulkAddressMatch`, data)
    }

    static async downloadW8PDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetW8PDF`, { params })
    }

    static async downloadW9PDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetW9PDF`, { params })
    }

    static async bulkInactivate(data) {
        return await AppDataService.put(`${COMMON_BASE}/DeActivate`, data)
    }

    static async bulkReactivate(data) {
        return await AppDataService.put(`${COMMON_BASE}/Activate`, data)
    }

    static async getRecipientLists(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetRecipientList`, { params })
    }

    static async switchRecipients(data) {
        return await AppDataService.post(`${COMMON_BASE}/SwitchRecipients`, data)
    }

    static async getConsentDetails(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetConsentDetails`, data);
    }

    static async consentMatchFee(count) {
        return await AppDataService.get(`${COMMON_BASE}/ConsentMatchFee?count=${count}`)
    }
    static async consentUpdate(data) {
        return AppDataService.post(`${COMMON_BASE}/ConsentUpdate`, data)
    }

    static async getTinMatchFee(count) {
        return await AppDataService.get(`${COMMON_BASE}/TinMatchFee?count=${count}`)
    }

    static async getTinMatchFilingFee(data) {
        return await AppDataService.post(`${COMMON_BASE}/TinMatchFilingFee`, data);
    }

    static async getW8W9Fees(count) {
        return await AppDataService.get(`${COMMON_BASE}/W8W9Fee?count=${count}`)
    }

    static async blockTinMatch(recipientId) {
        return await AppDataService.get(`${COMMON_BASE}/BlockTinmatch?recipientId=${recipientId}`)
    }

    static async unBlockTinMatch(recipientId) {
        return await AppDataService.get(`${COMMON_BASE}/UnBlockTinmatch?recipientId=${recipientId}`)
    }

    static async UpdateEmail(data) {
        return await AppDataService.put(`${COMMON_BASE}/UpdateEmail`, data)
    }
}